/**
 * "Produkt dodany do koszyka" toast (Figma node 2040:87) for the gallery
 * and row product views — not quick-order, which has its own inline
 * quantity/unit flow and never triggers WooCommerce's "added_to_cart" event
 * the same way.
 *
 * WooCommerce's own core add-to-cart.js already fires a jQuery event
 * (`added_to_cart`, on document.body) after every successful AJAX add, with
 * the clicked button as its 4th argument — no custom AJAX or event wiring
 * needed here, just listening for it. Re-skinning iziToast (see
 * src/styles/_add-to-cart-toast.scss) instead of hand-rolling the
 * timer/progress-bar/stacking/close/accessibility behavior a toast needs.
 */

import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

const jq = window.jQuery;

if (jq) {
	iziToast.settings({
		class: 'nitai-toast',
		close: true,
		closeOnClick: false,
		icon: false,
		position: 'topRight',
		progressBar: true,
		theme: 'light',
		timeout: 3000,
		transitionIn: 'fadeInDown',
		transitionOut: 'fadeOutUp',
	});

	jq(document.body).on('added_to_cart', (event, fragments, cartHash, $button) => {
		const productName = $button ? $button.data('product_name') : '';

		iziToast.show({
			title: 'Produkt dodany do koszyka',
			message: productName || '',
		});
	});
}
